import { t } from '@/plugins/i18n'
export const editableTabs = [
  {
    title: t('全部'),
    name: 'all'
  },
  {
    title: t('待处理'),
    name: '-1,0,1,2,3,4'
  },
  {
    title: t('已发货'),
    name: '5'
  },
  {
    title: t('已取消'),
    name: '10'
  },
  {
    title: t('待确认运输方式'),
    name: 'ConfirmType'
  }
]

export const storeColumns:any = [
  {
    label: t('国际物流单号'),
    prop: 'deliveryTaskCode',
    align: 'center',
    slotName: 'deliveryTaskCode',
    width: 200
  },
  {
    label: t('标题'),
    prop: 'deliveryTitle',
    align: 'center',
    width: 200
  },
  {
    label: t('发货类型'),
    prop: 'thirdWarehouseType',
    align: 'center',
    slotName: 'thirdWarehouseType'
  },
  {
    label: t('发货状态'),
    prop: 'deliveryStatus',
    align: 'center',
    slotName: 'deliveryStatus'
  },
  {
    label: t('运输方式'),
    prop: 'shippingtype',
    align: 'center',
    slotName: 'shippingtype',
    width: 260
  },
  {
    label: t('发货时间'),
    prop: 'deliveryTime',
    align: 'center',
    slotName: 'deliveryTime'
  },
  {
    label: t('运单号'),
    prop: 'logisticsDetailList',
    align: 'center',
    slotName: 'logisticsDetailList',
    width: 160
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  }
]
export const confirmOrderColumns:any = [
  {
    label: t('国际物流单号'),
    prop: 'deliveryTaskCode',
    align: 'center',
    slotName: 'deliveryTaskCode',
    width: 200
  },
  {
    label: t('标题'),
    prop: 'deliveryTitle',
    align: 'center'
  },
  {
    label: t('发货类型'),
    prop: 'thirdWarehouseType',
    align: 'center',
    slotName: 'thirdWarehouseType'
  },

  {
    label: t('原运输方式'),
    prop: 'originalDistribution',
    align: 'center',
    width: 260
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    slotName: 'changeReason',
    align: 'center'
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    align: 'center',
    slotName: 'recommendDistribution'
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  }
]
export const confirmSkuColumns:any = [
  {
    label: t('国际物流单号'),
    prop: 'deliveryTaskCode',
    align: 'center',
    slotName: 'deliveryTaskCode',
    width: 200
  },
  {
    label: t('标题'),
    prop: 'deliveryTitle',
    align: 'center'
  },
  {
    label: t('发货类型'),
    prop: 'thirdWarehouseType',
    align: 'center',
    slotName: 'thirdWarehouseType'
  },
  {
    label: t('原运输方式'),
    prop: 'originalDistribution',
    align: 'center'
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center',
    width: 260,
    slotName: 'createTime'
  }
]
export const confirmSkuSecondColumns:any = [
  {
    label: t('商品图片'),
    prop: 'productImage',
    align: 'center',
    slotName: 'productImage',
    width: 200
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('下单数量'),
    prop: 'deliveryNums',
    align: 'center'
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    align: 'center',
    slotName: 'changeReason',
    width: 260
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    align: 'center',
    slotName: 'recommendDistribution',
    width: 260
  }
]
/** 待确认-sku-dialog */
export const skuDialogColumns:any = [
  {
    label: t('图片'),
    prop: 'productImage',
    align: 'center',
    slotName: 'productImage'
    // width: 120
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    align: 'center',
    slotName: 'productSkuInfo',
    width: 200
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 200
  },
  {
    label: t('下单数量'),
    prop: 'deliveryNums',
    align: 'center'
    // width: 120
  },
  {
    label: t('变更理由'),
    prop: 'changeReason',
    align: 'center',
    slotName: 'changeReason'
    // width: 120
  },
  {
    label: t('建议运输方式'),
    prop: 'recommendDistribution',
    slotHeadName: 'recommendDistributionHead',
    align: 'center',
    slotName: 'recommendDistribution',
    width: 120
  },
  {
    label: t('处理方式'),
    prop: 'handleWay',
    align: 'center',
    slotName: 'handleWay',
    width: 220
  }
]

export const tableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: ' ', width: 280 }
}
export const tableConfigSku = {
  // showSelection: true,
  showHandler: true,
  showExpand: true,
  setHeight: true,
  rowKey: 'deliveryTaskCode',
  handlerConfig: { label: ' ', width: 280 }
}
export const tableConfigSkuDialog = {
  showSelection: true,
  // showHandler: true,
  setHeight: true
  // handlerConfig: { label: t('处理方式'), align: 'center' }
}

export const deliveryTypeOption: any = {
  1: t('普通发货'),
  0: t('FBA发货')
}

export const deliveryTypeDict: any = {
  0: t('FBA发货'),
  1: t('普通发货'),
  2: t('小件'),
  3: t('次品退货'),
  4: t('异常退货'),
  5: t('仓库调拨')
}

export const thirdWarehouseTypeDict: any = {
  0: t('其他'),
  1: t('FBA发货'),
  2: t('乐天'),
  3: t('SHOPLIST'),
  4: t('ZOZOTOWN')
}

export const deliveryStatusDict: any = {
  '-1': t('待处理'),
  0: t('待处理'),
  1: t('拣货中'),
  2: t('打标中'),
  3: t('打包中'),
  4: t('打包完成'),
  5: t('已发货'),
  10: t('已取消')
}
export const changeReasonCodes: any = {
  AR_0000: '-',
  AR_0001: t('涉及药事法'),
  AR_0002: t('涉及食品法'),
  AR_0003: t('带电池'),
  AR_0004: t('木制品'),
  AR_0005: t('侵权产品'),
  AR_0006: t('易燃易爆物品'),
  AR_0007: t('武器配件，管制刀具等'),
  AR_0008: t('动植物产品'),
  AR_0009: t('不满足发货重量要求'),
  AR_0010: t('价格过高'),
  AR_0011: t('粉末'),
  AR_0012: t('液体'),
  AR_0013: t('化妆品'),
  AR_0014: t('纯电商品'),
  AR_0015: t('带磁商品'),
  AR_0016: t('玩具')
}
/** 后端返回字段confirmType */
export const confirmTypes = {
  /** 未确认 */
  Unconfirmed: 0,
  /** 接受 */
  Accept: 1,
  /** 取消订单 */
  Cancel_Order: 2,
  /** 拒绝按照原来方式运输 */
  Original_Modeof_Transport: 3
}
